import { _user, _Config } from "@discovery/common-dplus/lib/state";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
export const useUser = () => {
    const [userM] = useGlobalState(_user);
    const [configM] = useGlobalState(_Config);
    const premiumPackagesM = M.chain((x) => x.premiumPackages, configM);
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const userPackagesM = M.chain((user) => user.attributes.packages, userM);
    const userPackages = M.fromMaybe(userPackagesM, []);
    const isPremiumUser = userPackages.includes(premiumPackages[0]);
    const userDetails = {
        idM: M.map((user) => user.id, userM),
        anonymousM: M.map((user) => user.attributes.anonymous, userM),
        packagesM: M.chain((user) => user.attributes.packages, userM),
        firstNameM: M.chain((user) => user.attributes.firstName, userM),
        lastNameM: M.chain((user) => user.attributes.lastName, userM),
        location: M.map((user) => user.attributes.currentLocationTerritory, userM),
        realm: M.map((user) => user.attributes.realm, userM),
    };
    const userId = M.fromMaybe(userDetails.idM, "");
    const isAnonymous = M.fromMaybe(userDetails.anonymousM, false);
    const firstName = M.fromMaybe(userDetails.firstNameM, "");
    const lastName = M.fromMaybe(userDetails.lastNameM, "");
    return {
        premiumPackagesM,
        userPackagesM,
        isAnonymous,
        isPremiumUser,
        userId,
        firstName,
        lastName,
    };
};

